<template>
  <div>
    <!-- My Schedule Status Table -->
    <my-schedule-status-table />
    <!-- /My Schedule Status Table -->

    <!-- Today Work -->
    <b-card class="today-work-wrap">
      <div class="work-wrap">
        <ul class="status-list-wrap">
          <li class="status-list">
            <button type="button" class="status-item">
              <span class="status">To Do</span>
              <span class="num">01</span>
            </button>
          </li>
          <li class="status-list bg-gray">
            <button type="button" class="status-item">
              <span class="status">In Progress</span>
              <span class="num">03</span>
            </button>
          </li>
          <li class="status-list bg-gray">
            <button type="button" class="status-item">
              <span class="status">Done</span>
              <span class="num">02</span>
            </button>
          </li>
          <li class="status-list bg-gray">
            <button type="button" class="status-item">
              <span class="status">Cancelled</span>
              <span class="num">01</span>
            </button>
          </li>
        </ul>
      </div>
    </b-card>
    <!-- /Today Work -->

    <!-- Card -->
    <b-card class="my-schedule-list">

      <!-- Card header -->
      <template #header>
        <div class="d-flex align-items-center justify-content-between">
          <div class="title-wrap">
            <h3>
              <span>My ToDo List</span>
              <b-button variant="outline-none" @click="refreshMyScheduleList" class="btn-refresh">
                <refresh-icon />
              </b-button>
            </h3>
          </div>

          <div class="btn-wrap">
            <b-button variant="outline-success" class="btn btn-primary small"
              @click="pushRoute('/chatter/my-schedule-new')">Create
            </b-button>
          </div>
        </div>
      </template>
      <!-- /Card header -->

      <!-- Card body -->
      <template #default>
        <div style="position:relative">

          <!-- Spinner -->
          <loading :active="loading" :is-full-page="false" />
          <!-- /Spinner -->

          <!-- Filter -->
          <my-schedule-filter @reload="reloadMyScheduleList" />
          <!-- /Filter -->

          <!-- Table -->
          <div class="custom-table-container">
            <table class="table table-hover custom-table">
              <colgroup>
                <col v-for="column in columns" :key="column.name" :width="column.width" />
              </colgroup>

              <thead>
                <tr class="text-center table-dark">
                  <th v-for="column in columns" :key="column.name" @click="sort(column)" class="my-schedule-list-header">
                    {{ column.name | formatColumnName }}
                    <b-icon-triangle-fill v-if="column.sort === 'ASC'" font-scale="0.75" />
                    <b-icon-triangle-fill flip-v v-else-if="column.sort === 'DESC'" font-scale="0.75" />
                  </th>
                </tr>
              </thead>

              <tbody v-if="mySchedules.length !== 0">
                <tr v-for="(mySchedule, index) in mySchedules" :key="index"
                  @click="showMyScheduleDetail(mySchedule.myScheduleId)" style="cursor: pointer;"
                  :style="rowColor(mySchedule)">

                  <!-- My Schedule ID -->
                  <td class="text-center align-middle">
                    <b-badge class="btn updated" variant="danger" :disabled="true" v-if="mySchedule.updated">Updated
                    </b-badge>
                    {{ mySchedule.myScheduleId }}
                  </td>
                  <!-- /Chat ID -->

                  <!-- Status -->
                  <td class="text-center align-middle">
                    <!-- 태그 별 클래스 추가 위한 함수 추가 / in-progress 이면서 due date 지났을 경우, 클래스 in-progress-red 추가  -->
                    <span class="status-tag" :class="getStatusTagClass(mySchedule.status)">{{ mySchedule.status |
                      formatStatus }}</span>
                  </td>
                  <!-- /Status -->

                  <!-- Title -->
                  <td class="align-middle">
                    <div class="title-wrap">
                      <div class="title-container">
                        <!-- Parent my schedule title -->
                        <b-form-row>
                          <b-collapse v-if="mySchedule.subordinateTo"
                            :id="'my-schedule-hierarchy' + mySchedule.myScheduleId" class="my-schedule-hierarchy"
                            style="margin-bottom: 6px; padding-left: 5px;">
                            {{ mySchedule.subordinateTo.title }}
                          </b-collapse>
                        </b-form-row>
                        <!-- /Parent my schedule title -->

                        <b-form-row>
                          <b-col>
                            <!-- Current my schedule title -->
                            <span v-if="mySchedule.subordinateTo && mySchedule.isExpanded === true"
                              style="display: inline-block; transform: translateY(-4px);">
                              <SubordinateToArrowIcon />
                            </span>
                            <span class="title-text">{{ mySchedule.title }}</span>
                            <!-- /Current my schedule title -->

                            <!-- Level -->
                            <span :style="{ color: getIconColor(mySchedule.level, 'square') }">
                              <span v-if="mySchedule.level !== ''" class="level-circle">●</span>
                            </span>
                            <!-- /Level -->

                            <!-- Subordinate To icon: shows a popover when hovered -->
                            <button type="button" @click.stop
                              v-if="mySchedule.subordinateTo != null && mySchedule.isExpanded === false"
                              :id="'popover-subordinateTo' + mySchedule.myScheduleId + mySchedule.subordinateTo.myScheduleId"
                              class="btn-subordinate">
                              <span class="icon">
                                <SubordinateToIcon />
                              </span>
                              <span class="icon-arrow"></span>
                              <b-popover
                                :target="'popover-subordinateTo' + mySchedule.myScheduleId + mySchedule.subordinateTo.myScheduleId"
                                triggers="hover" placement="top">
                                <template #title>Superior To</template>
                                <b-form-row selectable
                                  @click="showMyScheduleDetail(mySchedule.subordinateTo.myScheduleId)"
                                  style="cursor:pointer;">
                                  {{ `[${mySchedule.subordinateTo.myScheduleId}] ${mySchedule.subordinateTo.title}` }}
                                </b-form-row>
                              </b-popover>
                            </button>
                            <!-- /Subordinate To icon: shows a popover when hovered -->

                            <!-- Superior To icon: shows a popover when hovered -->
                            <button type="button" @click.stop
                              v-if="mySchedule.superiorTo.length > 0 && mySchedule.isExpanded === false"
                              :id="'popover-superiorTo' + mySchedule.myScheduleId + mySchedule.superiorTo.myScheduleId"
                              class="btn-superior">
                              <span class="icon">
                                <SuperiorToIcon />
                              </span>
                              <span class="icon-arrow"></span>
                              <b-popover
                                :target="'popover-superiorTo' + mySchedule.myScheduleId + mySchedule.superiorTo.myScheduleId"
                                triggers="hover" placement="bottom">
                                <template #title>Subordinate To</template>
                                <b-form-row v-for="mySchedule in mySchedule.superiorTo" :key="mySchedule.myScheduleId"
                                  selectable @click="showMyScheduleDetail(mySchedule.myScheduleId)"
                                  style="cursor:pointer;">
                                  {{ '[' + mySchedule.myScheduleId + '] ' + mySchedule.title }}
                                </b-form-row>
                              </b-popover>
                            </button>
                            <!-- /Superior To icon: shows a popover when hovered -->
                          </b-col>

                          <!-- Expansion button: shows all related chatters -->
                          <b-col cols="1" v-if="mySchedule.subordinateTo != null || mySchedule.superiorTo.length > 0"
                            style="text-align: end; display: flex; align-items: center;">
                            <b-badge class="btn" variant="secondary"
                              v-b-toggle="'my-schedule-hierarchy' + mySchedule.myScheduleId"
                              @click.stop="mySchedule.isExpanded = !mySchedule.isExpanded">
                              <span style="font-weight:bold;">
                                {{ mySchedule.isExpanded ? "-" : "+" }}
                              </span>
                            </b-badge>
                          </b-col>
                          <!-- Expansion button: shows all related chatters -->
                        </b-form-row>

                        <!-- Child chatters title -->
                        <b-form-row>
                          <b-col cols="11">
                            <b-collapse v-if="mySchedule.superiorTo.length > 0 && mySchedule.isExpanded === true"
                              :id="'my-schedule-hierarchy' + mySchedule.myScheduleId">
                              <b-form-row v-for="child in mySchedule.superiorTo" :key="child.myScheduleId" selectable
                                @click="showMyScheduleDetail(child.myScheduleId)" style="cursor:pointer;">
                                <span style="display: inline-block; transform: translateY(-4px); margin-left: 20px;">
                                  <SuperiorToArrowIcon />
                                </span>
                                <span class="my-schedule-hierarchy">{{ child.title }}</span>
                              </b-form-row>
                            </b-collapse>
                          </b-col>
                        </b-form-row>
                        <!-- /Child chatters title -->

                      </div>
                    </div>
                  </td>
                  <!-- /Title -->

                  <!-- Priority -->
                  <td class="text-center" :style="{ color: getIconColor(mySchedule.level, 'arrow') }">
                    {{ mySchedule.priority | formatPriority }}
                  </td>
                  <!-- /Priority -->

                  <!-- Start date ~ Due date -->
                  <td class="text-center align-middle">
                    <span v-if="mySchedule.startDate != '-'" style="white-space: nowrap">{{ mySchedule.startDate }}</span>
                    <span v-if="mySchedule.startDate != '-' || mySchedule.dueDate != '-'"> ~ </span>

                    <span v-if="mySchedule.dueDate != '-'" style="white-space: nowrap">{{ mySchedule.dueDate }}</span>
                  </td>
                  <!-- /Start date ~ Due date -->
                </tr>
              </tbody>

              <tbody v-else>
                <tr>
                  <td colspan="11" style="text-align:center">결과가 없습니다.
                  </td>
                </tr>
              </tbody>

            </table>
          </div>
          <!-- Table -->

          <!-- See More button -->
          <div class="btn-more-area">
            <button class="btn btn-view-more" @click="seeMore" :disabled="mySchedules.length >= total || total < 11">
              <span class="icon"><see-more-icon /></span>
              <span style="font-weight: 700;">See More&nbsp;</span>
              <span>({{ mySchedules.length }}/{{ total }})</span>
            </button>
          </div>
          <!-- See More button -->
        </div>
      </template>
      <!-- Card body -->
    </b-card>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import MyScheduleStatusTable from "@/components/chatter/MyScheduleStatusTable.vue";
import MyScheduleFilter from '@/components/chatter/MyScheduleFilter.vue';

import RefreshIcon from "@/components/chatter/icons/RefreshIcon.vue";
import SubordinateToArrowIcon from "@/components/chatter/icons/SubordinateToArrowIcon.vue";
import SuperiorToArrowIcon from "@/components/chatter/icons/SuperiorToArrowIcon.vue";
import SubordinateToIcon from "@/components/chatter/icons/SubordinateToIcon.vue";
import SuperiorToIcon from "@/components/chatter/icons/SuperiorToIcon.vue";
import SeeMoreIcon from "@/components/chatter/icons/SeeMoreIcon.vue";

export default {
  name: "MyScheduleList",
  components: {
    Loading,
    MyScheduleFilter,
    MyScheduleStatusTable,

    RefreshIcon,
    SubordinateToArrowIcon,
    SuperiorToArrowIcon,
    SuperiorToIcon,
    SubordinateToIcon,
    SeeMoreIcon
  },
  computed: {
    mySchedules() {
      return this.$store.getters['mySchedule/mySchedules'];
    },
    total() {
      return this.$store.getters['mySchedule/total'];
    },
    filter() {
      return this.$store.getters['mySchedule/filter'];
    },
    options() {
      return this.$store.getters['mySchedule/options'];
    },
    occupied() {
      return this.$store.getters['mySchedule/occupied'];
    },
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    userId() {
      return this.currentUser.caller;
    },
    updated() {
      return this.$store.getters['mySchedule/getUpdated'];
    },
  },
  watch: {
    updated(value) { // computed에 지정한 updated 속성이 바뀌면 콜백 실행
      if (value === 'Y') {
        this.reloadMyScheduleList();
      }
    }
  },
  data() {
    return {
      loading: false,
      columns: [
        { name: 'id', colName: 'my_schedule_id', sort: '', width: "15%" },
        { name: 'status', colName: 'status', sort: '', width: "15%" },
        { name: 'title', colName: 'title', sort: '', width: "40%" },
        { name: 'priority', colName: 'priority', sort: '', width: "10%" },
        { name: 'start ~ Due Date', colName: 'start_date', sort: '', width: "25%" },
      ],
      chattererOptions: [],
      sortedColumns: [],
    }
  },
  created() {
    //if (this.mySchedules.length === 0) {
    this.retrieveMyScheduleList();
    //}
  },
  methods: {
    async retrieveMyScheduleList() {
      // If My Schedule Status Table has already occupied the list, return
      // For details, refer to My Schedule Vuex (mySchedule.module.js)
      if (this.occupied) return;
      try {
        this.loading = true;
        // Fetch chats
        let response = await axios.post('/chatter/retrieveMyScheduleList',
          this.filter,
          { headers: { Authorization: accessToken() } }
        );
        // Commit the newly fetched My Schedule to Vuex
        response.data.list.forEach(item => item.isExpanded = false);
        this.$store.commit('mySchedule/setMySchedules', response.data.list);

        // Set the total number of My Schedule in Vuex
        this.$store.commit('mySchedule/setTotal', response.data.total);

      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    refreshMyScheduleList() {
      this.$store.commit('mySchedule/setOccupied', false);
      this.$store.commit('mySchedule/setTotal', 0);
      this.$store.commit('mySchedule/resetFilter');
      this.retrieveMyScheduleList();
    },
    reloadMyScheduleList() {
      this.$store.commit('mySchedule/setTotal', 0);
      this.$store.commit('mySchedule/setPage', 1);
      this.retrieveMyScheduleList();
    },
    seeMore() {
      this.$store.commit('mySchedule/incrementPage');
      this.retrieveMyScheduleList();
    },
    sort(column) {
      // Switch sorting order
      column.sort = ({
        '': 'ASC',
        ASC: 'DESC',
        DESC: ''
      })[column.sort];

      // Commit sorting orders
      this.$store.commit('mySchedule/setSort', this.columns)

      // Reload chatter list
      this.reloadMyScheduleList();
    },
    substatus(mySchedule) {
      let inactive = ['DONE', 'CLOSED', 'CANCELLED']
      if (inactive.includes(mySchedule.status) || mySchedule.dueDate === '-') {
        return 'unknown';
      } else if (mySchedule.dueDate === this.today) {
        return 'dueOnToday';
      } else if (mySchedule.dueDate < this.today) {
        return 'overdue';
      }
    },
    rowColor(mySchedule) {
      return {
        color: ({
          dueOnToday: 'GoldenRed',
          overdue: 'Red',
          unknown: 'Black'
        })[this.substatus(mySchedule)]
      }
    },
    getIconColor(level, type) {
      switch (type) {
        case 'square':
          switch (level) {
            case '3':
              return '#FF0000';
            case '2':
              return '#FF9900';
            case '1':
              return '#FFE600';
            case '0':
              return '#C4C4CD';
            default:
              return '';
          }
      }
    },
    showMyScheduleDetail(myScheduleId) {
      this.$router.push({ name: "myScheduleDetail", params: { id: myScheduleId } });
    },
    getStatusTagClass(status) {
      return status.replace('_', '-').toLowerCase();
    },
  },
  filters: {
    formatStatus(strStatus) {
      let arrStrStatus = strStatus.split("_");
      let result = '';
      for (let i in arrStrStatus) {
        let str = arrStrStatus[i]
        result = result + " " + str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      }
      return result
    },
    formatColumnName(name) {
      // 첫 글자를 대문자로 변경하고 중간에 대문자가 있는 경우 띄어쓰기 추가
      if (name.toUpperCase() === "ID") {
        // Exception. Id의 경우 모두 대문자로 변환하여 사용 - 20230614 박선익
        return name.toUpperCase()
      }
      return name.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
        return str.toUpperCase();
      });
    },
    formatPriority(priority) {
      switch (priority) {
        case '2': // High
          // return '↑';
          return 'High';
        case '1': // Medium
          // return '-';
          return 'Medium';
        case '0': // Low
          // return '↓';
          return 'Low';
        case '-':
          return '';
        default:
          return '';
      }
    },
  },
}
</script>
<style>
td {
  vertical-align: middle;
}

.down-arrow-icon {
  transform: translate(-50%, -50%) rotate(180deg);
  margin-left: 1em;
}

.mySchedule-list-header {
  user-select: none;
  /* 드래그 불가능 */
  cursor: pointer;
  /* 포커스 시 커서를 손가락 모양으로 설정 */
}

.tooltip .tooltip-inner {
  max-width: 1000px !important;
  white-space: pre-wrap !important;
  text-align: start;
}

.popover {
  max-width: 1000px !important;
}

#export .modal-dialog {
  padding: 0;
}

#export .modal-body {
  padding: 0;
}

/* excel export 팝업 */
.popup-export.modal.show .modal-dialog {
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.popup-export .modal-content {
  border-radius: 20px;
}

.popup-export .modal-header {
  align-items: center;
  padding: 2.083vw 2.666rem 1.041vw;
  border-radius: 20px 20px 0 0;
  border-bottom: 0px;
}

.popup-export .modal-title {
  margin-bottom: 0 !important;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
}

.popup-export .modal-header .close {
  width: 30px;
  height: 30px;
  margin: 0;
  font-size: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M22.5 22.5L7.5 7.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.5 7.5L7.5 22.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.popup-export#export .modal-body {
  padding: 1.041vw 2.666rem;
}

.popup-export label {
  padding-left: 0.4rem;
  margin-bottom: 0.53rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.popup-export .modal-body .custom-select {
  -o-appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.popup-export .btn-wrap {
  display: flex;
  align-items: center;
  gap: 0 0.666rem;
  padding: 2.604vw 0 1.562vw;
}

.popup-export .btn-wrap .btn {
  border-color: transparent;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.popup-export .btn-wrap .btn-primary.small {
  width: 148px;
  height: 40px;
  background-color: #2E2E38;
  color: #FFE600;
}

.popup-export .btn-wrap .btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

.popup-export .btn-wrap .btn-primary.disabled,
.popup-export .btn-wrap .btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.popup-export .btn-wrap .btn-secondary.small {
  width: 148px;
  height: 40px;
  border-radius: 10px;
  background: #747480;
  color: #fff;
}

.popup-export .btn-wrap .btn-secondary:hover {
  background-color: #565662;
}

.popup-export .btn-wrap .btn-secondary.disabled,
.popup-export .btn-wrap .btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}
</style>
  
<style scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

/* button */
.btn {
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.btn:focus {
  box-shadow: none;
}

.btn-primary {
  width: 280px;
  height: 60px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

.btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.btn-primary.small {
  width: 148px;
  height: 40px;
}

.btn-export {
  width: 148px;
  height: 40px;
  background-color: #168D4C;
  color: #fff;
  border-color: transparent;
}

.btn-export:hover {
  background-color: #006F2E;
  border-color: transparent;
}

.btn-export.disabled,
.btn-export:disabled {
  color: #62796D;
  background-color: #759483;
}

.btn.btn-line {
  position: relative;
  width: 100px;
  height: 60px;
  border: 1px solid #C4C4CD;
  background-color: transparent;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  text-align: inherit;
}

.btn.btn-line:hover {
  color: #2E2E38;
  border: 1px solid #2E2E38;
  background-color: transparent;
}

.btn.btn-line.disabled,
.btn.btn-line:disabled {
  border: 1px solid #DDDDE3;
  background-color: transparent;
}

.btn.btn-line.small {
  height: 40px;
  text-align: center;
}

.btn-refresh {
  height: auto;
  padding: 0;
}

/* 공통요소 */
.select-custom-scrollbar::-webkit-scrollbar {
  width: 12px;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-track {
  width: 6px;
  background-color: #E7E7EE;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-thumb {
  width: 100%;
  background-color: #C4C4CD;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

/* card 영역 */
.card {
  margin-bottom: 2rem;
  border-radius: 30px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  font-family: 'NanumGothic';
}

.card>.card-body {
  padding-top: max(2rem, 1.5625vw);
  padding-left: 2.0833vw;
  padding-right: 2.0833vw;
  padding-bottom: max(2.666rem, 2.0833vw);
}

/* today work 영역 */
.card.today-work-wrap .card-body {
  padding-bottom: max(2rem, 1.5625vw);
}

.work-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0 1.333rem;
}

.work-wrap .work-progress .title-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.533rem;
}

.work-wrap .work-progress .title-wrap .title {
  font-size: 18px;
  font-weight: 700;
}

.work-wrap .work-progress .title-wrap .rate {
  font-size: 14px;
  font-weight: 400;
  color: #06F;
}

.work-wrap .work-progress .title-wrap .rate span:first-child {
  font-weight: 700;
}

.work-wrap .work-progress .progress-bar {
  width: 17.3333rem;
  height: 26px;
  border-radius: 8px;
  border: 1px solid rgba(0, 102, 255, 0.10);
  background-color: #D8E7FF;
}

.work-wrap .work-progress .progress-bar .bar {
  height: 100%;
  background-color: #06F;
}

.work-wrap .work-progress {
  flex-grow: 0;
  flex-shrink: 1;
  margin-right: 60px;
}

.work-wrap .status-list-wrap {
  flex-shrink: 1;
  flex-grow: 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9.333rem, auto));
  gap: 0.4rem;
  padding: 0;
  margin: 0;
  list-style: none;
}

.work-wrap .status-list-wrap .status-list {
  /* min-width: 140px; */
  height: 40px;
}

.work-wrap .status-list-wrap .status-list .status-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0 10px;
  min-width: 100%;
  height: 100%;
  padding: 0 0.466rem 0 0.8rem;
  border-radius: 34px;
  border: 1px solid #DDDDE3;
  background-color: #fff;
  font-size: 14px;
  color: #2E2E38;
}

.work-wrap .status-list-wrap .status-list:hover .status-item {
  border: 1px solid #2E2E38;
}

.work-wrap .status-list-wrap .status-list .status-item span {
  display: inline-block;
}

.work-wrap .status-list-wrap .status-list.bg-gray .status-item {
  border: 1px solid transparent;
  background-color: #E7E7EE;
}

.work-wrap .status-list-wrap .status-list.bg-gray:hover .status-item {
  background-color: #D4D4DC;
}

.work-wrap .status-list-wrap .status-list.bg-bk .status-item {
  border: 1px solid transparent;
  background-color: #40404B;
  color: #fff;
}

.work-wrap .status-list-wrap .status-list.bg-bk:hover .status-item {
  background-color: #1B1B1B;
}

.work-wrap .status-list-wrap .status-item .status {
  font-weight: 500;
  line-height: 150%;
}

.work-wrap .status-list-wrap .status-item .num {
  height: 26px;
  padding: 0 0.5rem;
  border-radius: 30px;
  background-color: #fff;
  color: #2E2E38;
  text-align: center;
  line-height: 26px;
  font-weight: 700;
  font-size: 14px;
}

.work-wrap .status-list-wrap .status-list.bg-bk .status-item .num {
  background-color: transparent;
  color: #fff;
}

/* mySchedule list 영역 */
.card.my-schedule-list {
  margin-bottom: 2rem;
  border-radius: 30px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

.card.my-schedule-list .card-header {
  padding-top: max(2rem, 1.5625vw);
  padding-left: 2.0833vw;
  padding-right: 2.0833vw;
  padding-bottom: calc(max(2.666rem, 2.0833vw) - 1rem);
  border-radius: 30px 30px 0 0;
  border-bottom: none;
}

.card.my-schedule-list .card-header .title-wrap {
  display: flex;
  gap: 0 1.333rem;
}

.card.my-schedule-list .card-header h3 {
  display: flex;
  align-items: center;
  gap: 0 1.333rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
}

.card.my-schedule-list .card-header .btn-wrap {
  display: flex;
  gap: 0 2rem;
}

.card.my-schedule-list .card-header .btn-wrap .btn-group-area {
  position: relative;
  display: flex;
  gap: 0 0.666rem;
}

.card.my-schedule-list .card-header .btn-wrap .btn-group-area::after {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  right: -1rem;
  transform: translateY(-50%);
  width: 1px;
  height: calc(100% - 1.066rem);
  background-color: #DDDDE3;
}

/* my-schedule list table 영역 */
.custom-table-container {
  margin-top: 2.666rem;
  padding: 0.666rem;
  border-radius: 20px;
  background-color: #F6F6FA;
}

.table.custom-table {
  margin-bottom: 0;
}

.table.custom-table tr {
  color: #2E2E38;
  background-color: #FFF;
}

.table.custom-table tr:hover {
  background-color: #FAFAFA;
}

.table.custom-table thead th,
.table-bordered.custom-table th {
  height: 70px;
  padding-top: calc(0.75rem - 0.666rem);
  background-color: #F6F6FA;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #C4C4CD;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  vertical-align: middle;
  white-space: nowrap;
}

.table.custom-table td {
  min-height: 80px;
  padding: 1.333rem 0.666vw;
  border-top: 1px solid #E7E7EE;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  vertical-align: middle;
}

.table.custom-table td .title-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table.custom-table td .title-wrap .title-container {
  flex-grow: 1;
}

.table.custom-table td .title-wrap .title-text {
  font-weight: 700 !important;
}

.table.custom-table td .title-wrap .my-schedule-hierarchy {
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.btn-subordinate {
  display: inline-flex;
  gap: 0 0.533rem;
  align-items: center;
  height: 20px;
  padding: 0.266rem 0.4rem 0.266rem 0.533rem;
  margin-top: 0.266rem;
  margin-bottom: 0.266rem;
  margin-left: 1.041vw;
  border-radius: 70px;
  background-color: rgba(255, 229, 0, 0.7);
  border: none;
}

.btn-subordinate:hover {
  background-color: rgba(255, 229, 0, 1);
}

.btn-subordinate .icon-arrow {
  display: inline-block;
  width: 14px;
  height: 14px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.084 5.25L7.00065 9.33333L2.91732 5.25" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

.btn-subordinate.active {
  background-color: rgba(255, 229, 0, 1);
}

.btn-subordinate.active .icon-arrow {
  transform: rotate(180deg);
}

.btn-superior {
  display: inline-flex;
  gap: 0 0.533rem;
  align-items: center;
  height: 20px;
  padding: 0.266rem 0.4rem 0.266rem 0.533rem;
  margin-top: 0.266rem;
  margin-bottom: 0.266rem;
  margin-left: 1.041vw;
  border-radius: 70px;
  background-color: rgba(46, 46, 56, 0.8);
  border: none;
}

.btn-superior:hover {
  background-color: rgba(46, 46, 56, 1);
}

.btn-superior .icon-arrow {
  display: inline-block;
  width: 14px;
  height: 14px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.084 5.25L7.00065 9.33333L2.91732 5.25" stroke="%23FFE600" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

.btn-superior.active {
  background-color: rgba(46, 46, 56, 1);
}

.btn-superior.active .icon-arrow {
  transform: rotate(180deg);
}

.btn-superior+.btn-subordinate {
  margin-left: 0.52vw;
}

.table.custom-table tr:last-child td:first-child {
  border-radius: 0 0 0 10px;
}

.table.custom-table tr:last-child td:last-child {
  border-radius: 0 0 10px 0;
}

.table.custom-table .status-tag {
  display: inline-block;
  max-width: 100px;
  width: 100%;
  height: 29px;
  padding: 4px 6px;
  border-radius: 38px;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  white-space: nowrap
}

.table.custom-table .status-tag.in-progress {
  background-color: #F5ECD6;
  color: #FF5C00;
}

.table.custom-table .status-tag.in-progress-red {
  background-color: #F5D6D6;
  color: #F00;
}

.table.custom-table .status-tag.to-do {
  background-color: #F6F6FA;
  color: #2E2E38;
}

.table.custom-table .status-tag.done {
  background-color: #CFDDFF;
  color: #1755CC;
}

.table.custom-table .status-tag.closed {
  background-color: #D7F5D6;
  color: #168D4C;
}

.table.custom-table .status-tag.cancelled {
  background-color: #E4E4EA;
  color: rgba(116, 116, 128, 0.70);
}

.btn.updated {
  padding: 0;
  background-color: transparent;
  border-radius: 0;
  color: #1755CC;
  font-size: 12px;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  opacity: 1;
}

.level-circle {
  display: inline-block;
  font-size: 6px;
  margin-left: 0.533rem;
  transform: translateY(-1.5px);
}

.assignee-wrap {
  display: flex;
  align-items: center;
  gap: 0 0.729vw;
  width: 100%;
}

.assignee-wrap .user-profile {
  position: relative;
  flex-grow: 1;
  flex-shrink: 0;
  display: inline-block;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
}

.assignee-wrap .user-profile img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  object-fit: cover;
}

.assignee-wrap .assignee-name {
  width: calc(100% - 10px - 0.729vw);
  overflow: hidden;
  text-overflow: clip;
  /* text-overflow: ellipsis;  */
}

.btn-more-area {
  display: flex;
  justify-content: center;
  margin-top: 2.666rem;
}

.btn-more-area .btn-view-more {
  display: inline-block;
  width: auto;
  height: auto;
  margin: 0;
  padding: 1.3rem 3.3rem 1.3rem 3.033rem;
  border-radius: 60px;
  background-color: #E7E7EE;
}

.btn-more-area .btn-view-more .icon {
  margin-top: -3px;
  margin-right: 0.533rem;
}

.btn-more-area .btn-view-more span {
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  line-height: 150%;
}

.btn-more-area .btn-view-more:hover {
  background-color: #C4C4CD;
}
</style>